export type TMetadata = {
  pageId?: string;
  placeId?: string;
  rootPlaceId?: string;
  placeName?: string;
  privateServerLimit?: string;
  privateServerPrice?: string;
  universeId?: string;
  showShutDownAllButton?: boolean;
  userCanManagePlace?: boolean;
  canCreateServer?: boolean;
};
const booleanMetadataFields = ['showShutDownAllButton', 'userCanManagePlace', 'canCreateServer'];

const gameDetailsMetadataContainerId = 'game-detail-meta-data';
const gameDetailsMetadataContainer = (): HTMLElement | null =>
  document.getElementById(gameDetailsMetadataContainerId);
const metadataData = (): TMetadata => {
  const data = gameDetailsMetadataContainer()?.dataset || ({} as Record<string, any>);
  booleanMetadataFields.forEach(key => {
    if (data[key] === 'True') {
      data[key] = true;
    } else if (data[key] === 'False') {
      data[key] = false;
    }
  });

  return data;
};

export default {
  gameDetailsMetadataContainerId,
  gameDetailsMetadataContainer,
  metadataData
};
